import axios from 'axios';
import { API_URL } from "../../app/api.js";
import { checkReject, checkStatus, METHODS } from "../../app/request.js";

function getHeaders(json) {
    const sessionToken = localStorage.getItem('sessionToken');
    const headers = {
        'Authorization': `DXAPI ${sessionToken}`,
        'Access-Control-Allow-Origin': '*',
    };
    if (json) {
        headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return headers;
}

const liteTradeRequest = (url, method, optionsInit = {}) => {
    const apiTrade = localStorage.getItem('apiTrade') || API_URL;

    const options = Object.assign({}, optionsInit);
    options.headers = getHeaders(true);
    options.credentials = 'include';

    return axios({
        url: apiTrade + url,
        method,
        ...options,
    })
        .catch(checkReject)
        .then(checkStatus);
};

export const getLiteTradeRequest = (url, params = {}, options = {}) =>
    liteTradeRequest(url, METHODS.GET, { params, ...options });

export const postLiteTradeRequest = (url, body, params = {}, options = {}) =>
    liteTradeRequest(url, METHODS.POST, { data: body, params, ...options });

export const putLiteTradeRequest = (url, body, params = {}, options = {}) =>
    liteTradeRequest(url, METHODS.PUT, { data: body, params, ...options });

export const deleteLiteTradeRequest = (url, body, params = {}, options = {}) =>
    liteTradeRequest(url, METHODS.DELETE, { data: body, params, ...options });
